import { useQuery } from '@tanstack/react-query'

import { getLocations } from '@/lib/api/locations'
import { LocationData } from '@/lib/types'

const useLocations = () => {
  const { data, isLoading } = useQuery<LocationData[]>({
    queryKey: ['locations'],
    queryFn: () => getLocations()
  })

  return { locations: data, isLoading }
}

export default useLocations
